import {createRandomArray, createOrder} from '../moduls/utils';

const QUESTIONS_NUMBER = 10;

const questionsArray = createRandomArray(QUESTIONS_NUMBER);

const GAME_1 = [{
  id: 1,
  title: `1-й раунд`,
  start: '1-1',
  steps: {
    'start': {
      type: 'comment',
      comment: '',
      description: `<p>Закон о внесении поправок в Конституцию подписан президентом. Теперь дело за нами – на всенародном голосовании мы сможем выразить свою волю: сказать, хотим ли мы изменений Основного Закона. Пожалуй, не помешает убедиться – знаете ли вы, что дадут поправки в Конституцию?</p>`,
      specialClass: 'content__step_start',
      button: true,
      buttonText: 'Итак, поехали!',
      next: String(questionsArray[0])
    },
    '1-1': {
      type: 'simple-question',
      isMultiple: false,
      comment: '',
      description: `<p>Одной из главных целей нацпроекта «Образование» является глобальная конкурентоспособность российского образования. На практике это означает:</p>`,
      answers: [
        {
          title: 'Вхождение России в топ-10 ведущих стран мира по качеству общего образования.',
          next: '1-1a'
        },
        {
          title: 'Весь мир будет учиться по российским программам.',
          next: '1-1b'
        },
      ],
    },
    '1-1a': {
      type: 'comment',
      comment: 'Одной из главных целей нацпроекта «Образование» является глобальная конкурентоспособность российского образования. На практике это означает:',
      answerList: [
        ['Вхождение России в топ-10 ведущих стран мира по качеству общего образования.', 'selected'],
        ['Весь мир будет учиться по российским программам.', false]
      ],
      description: `<span>Правильный ответ!</span>`,
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '1-2'
    },
    '1-1b': {
      type: 'comment',
      comment: 'Одной из главных целей нацпроекта «Образование» является глобальная конкурентоспособность российского образования. На практике это означает:',
      answerList: [
        ['Вхождение России в топ-10 ведущих стран мира по качеству общего образования.', false],
        ['Весь мир будет учиться по российским программам.', 'selected']
      ],
      description: `<span>Неправильный ответ!</span><p>Это, пожалуй, перебор. А вот удачная модель обучения, наверняка, станет образцом для подражания во многих странах. Так уже было с советской школой, считавшейся лучшей в мире в конце 1950-х – начале 1960-х годов. Так, наверняка, будет и при достижении цели нацпроекта по вхождению России в топ-десятку ведущих стран мира по качеству общего образования.</p>`,
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '1-1'
    },

    '1-2': {
      type: 'simple-question',
      isMultiple: false,
      comment: '',
      description: `<p>Сетевая форма обучения – это:</p>`,
      answers: [
        {
          title: 'Возможность изучать отдельные предметы, курсы или модули не в своей, а в другой школе, колледже или даже в вузе с зачетом результатов освоения этих дополнительных программ в своей альма-матер.',
          next: '1-2a'
        },
        {
          title: 'Уроки, которые проходят в соцсетях.',
          next: '1-2b'
        },

      ],
    },
    '1-2a': {
      type: 'comment',
      comment: 'Сетевая форма обучения – это:',
      answerList: [
        ['Возможность изучать отдельные предметы, курсы или модули не в своей, а в другой школе, колледже или даже в вузе с зачетом результатов освоения этих дополнительных программ в своей альма-матер.', 'selected'],
        ['Уроки, которые проходят в соцсетях.', false]
      ],
      description: `<span>Правильный ответ!</span><p>Правильно, такая возможность предусмотрена <a href="https://xn--80aapampemcchfmo7a3c9ehj.xn--p1ai/projects/obrazovanie?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=obrazovanie" target="_blank" rel="noopener noreferrer">нацпроектом «Образование».</p>`,
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '1-3'
    },
    '1-2b': {
      type: 'comment',
      comment: 'Сетевая форма обучения – это:',
      answerList: [
        ['Возможность изучать отдельные предметы, курсы или модули не в своей, а в другой школе, колледже или даже в вузе с зачетом результатов освоения этих дополнительных программ в своей альма-матер.', false],
        ['Уроки, которые проходят в соцсетях.', 'selected']
      ],
      description: `<span>Неправильный ответ!</span><p>Смешно! Но в данном случае слово «сеть» используется в значении взаимодействия разных образовательных организаций между собой на так называемом горизонтальном уровне, что позволяет  школьнику изучать часть программы не в своей, а в других школах. Такая возможность предусмотрена <a href="https://xn--80aapampemcchfmo7a3c9ehj.xn--p1ai/projects/obrazovanie?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=obrazovanie" target="_blank" rel="noopener noreferrer">нацпроектом «Образование».</a></p>`,
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '1-2'
    },

    '1-3': {
      type: 'simple-question',
      isMultiple: false,
      comment: '',
      description: `<p>Кстати, учебный модуль – это:</p>`,
      answers: [
      	{
          title: 'Часть образовательной программы, в которой изучается несколько предметов и курсов.',
          next: '1-3a'
        },
        {
          title: 'Насчет образования не знаю, а в космонавтике это составная часть космического корабля, способная совершать самостоятельный полет.',
          next: '1-3b'
        },

      ],
    },
    '1-3a': {
      type: 'comment',
      comment: 'Кстати, учебный модуль – это:',
      answerList: [
        ['Часть образовательной программы, в которой изучается несколько предметов и курсов.', 'selected'],
        ['Насчет образования не знаю, а в космонавтике это составная часть космического корабля, способная совершать самостоятельный полет.', false]
      ],
      description: `<span>Правильный ответ!</span><p>Часто модулем называют также часть программы курса по конкретной дисциплине. А <a href="https://xn--80aapampemcchfmo7a3c9ehj.xn--p1ai/projects/obrazovanie?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=obrazovanie" target="_blank" rel="noopener noreferrer">нацпроект «Образование»</a> позволяет использовать модульную систему обучения.</p>`,
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '1-4'
    },
    '1-3b': {
      type: 'comment',
      comment: 'Кстати, учебный модуль – это:',
      answerList: [
        ['Часть образовательной программы, в которой изучается несколько предметов и курсов.', false],
        ['Насчет образования не знаю, а в космонавтике это составная часть космического корабля, способная совершать самостоятельный полет.', 'selected']
      ],
      description: `<span>Неправильный ответ!</span><p>В образовании примерно так же. Учебный модуль, дополнительно взятый еще в одной образовательной организации, – ну чем не самостоятельный полет к знаниям. Эту возможность дает нацпроект «Образование».`,
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '1-3'
    },

    '1-4': {
      type: 'simple-question',
      isMultiple: false,
      comment: '',
      description: `<p>Общеобразовательная организация – это:</p>`,
      answers: [
        {
          title: 'Школа.',
          next: '1-4a'
        },
        {
          title: 'Любое учебное заведение.',
          next: '1-4b'
        },

      ],
    },
    '1-4a': {
      type: 'comment',
      comment: 'Общеобразовательная организация – это:',
      answerList: [
        ['Школа.', 'selected'],
        ['Любое учебное заведение.', false]
      ],
      description: `<span>Правильный ответ!</span><p>Если по науке, то это образовательная организация, где учат по программам начального общего (1–4-е классы), основного общего (5–9-е классы) и (или) среднего общего образования (10–11-е классы). То есть, говоря проще, это школа (в отличие от колледжа, где учат по программам среднего профобразования, и вуза с его программами высшего образования).</p>`,
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '1-5'
    },
    '1-4b': {
      type: 'comment',
      comment: 'Общеобразовательная организация – это:',
      answerList: [
        ['Школа.', false],
        ['Любое учебное заведение.', 'selected']
      ],
      description: `<span>Неправильный ответ!</span><p>Вот и нет: на то школа и общеобразовательная организация, чтобы вооружить знаниями, необходимыми всем и каждому. А вот вуз или колледж дают особые, специальные знания – отсюда, кстати, и слово специальность. Эти организации, в отличие от школы, быть общеобразовательными никак не могут.</p>`,
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '1-4'
    },

    '1-5': {
      type: 'simple-question',
      isMultiple: false,
      comment: '',
      description: `<p>Демонстрационный экзамен – это:</p>`,
      answers: [
        {
          title: 'Модель независимой оценки качества подготовки кадров в системе профобразования, цель которой – обеспечить рынок труда квалифицированными  кадрами.',
          next: '1-5a'
        },
        {
          title: 'Выпускной экзамен, на котором школьники демонстрируют свои знания при большом стечении народа.',
          next: '1-5b'
        },

      ],
    },
    '1-5a': {
      type: 'comment',
      comment: 'Демонстрационный экзамен – это:',
      answerList: [
        ['Модель независимой оценки качества подготовки кадров в системе профобразования, цель которой – обеспечить рынок труда квалифицированными  кадрами.', 'selected'],
        ['Выпускной экзамен, на котором школьники демонстрируют свои знания при большом стечении народа.', false]
      ],
      description: `<span>Правильный ответ!</span><p><a href="https://xn--80aapampemcchfmo7a3c9ehj.xn--p1ai/projects/obrazovanie?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=obrazovanie" target="_blank" rel="noopener noreferrer">Нацпроект «Образование»</a> предусматривает модернизацию системы среднего профобразования, что позволит расширить практику сдачи демонстрационных экзаменов.</p>`,
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '1-6'
    },
    '1-5b': {
      type: 'comment',
      comment: 'Демонстрационный экзамен – это:',
      answerList: [
        ['Модель независимой оценки качества подготовки кадров в системе профобразования, цель которой – обеспечить рынок труда квалифицированными  кадрами.', false],
        ['Выпускной экзамен, на котором школьники демонстрируют свои знания при большом стечении народа.', 'selected']
      ],
      description: `<span>Неправильный ответ!</span><p>Нет, демонстрационный экзамен  сдают не школьники, а выпускники колледжей (иногда вузов), обучавшиеся по суперсовременным программам среднего профобразования, и носит он не теоретический, а практический характер, ибо выявляет профессиональные умения и навыки выпускников, проходит в условиях, максимально приближенных к производственным, а качество выполнения заданий оценивается независимыми экспертами-практиками.</p>`,
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '1-5'
    },

    '1-6': {
      type: 'simple-question',
      isMultiple: false,
      comment: '',
      description: `<p>Профессиональные компетенции – это:</p>`,
      answers: [
        {
          title: 'Навыки и умения.',
          next: '1-6a'
        },
        {
          title: 'То, чему учат в вузах и колледжах.',
          next: '1-6b'
        },

      ],
    },
    '1-6a': {
      type: 'comment',
      comment: 'Профессиональные компетенции – это:',
      answerList: [
        ['Навыки и умения.', 'selected'],
        ['То, чему учат в вузах и колледжах.', false]
      ],
      description: `<span>Правильный ответ!</span><p>Универсальные компетенции (навыки и умения), позволяющие решать практические вопросы и задачи в любой предметной области.</p>`,
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '1-7'
    },
    '1-6b': {
      type: 'comment',
      comment: 'Профессиональные компетенции – это:',
      answerList: [
        ['Навыки и умения.', false],
        ['То, чему учат в вузах и колледжах.', 'selected']
      ],
      description: `<span>Неправильный ответ!</span><p>Не совсем так. Многие программы профессионального обучения, особенно вузовские, носят чисто теоретический характер, хотя и они важны. А компетенции – это прежде всего практические навыки, то есть умение применять свои могучие познания на практике.</p>`,
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '1-6'
    },

    '1-7': {
      type: 'simple-question',
      isMultiple: false,
      comment: '',
      description: `<p>Система дополнительного образования – это:</p>`,
      answers: [
        {
          title: 'Кружки и секции.',
          next: '1-7a'
        },
        {
          title: 'Дополнительные занятия учителей с двоечниками. ',
          next: '1-7b'
        },

      ],
    },
    '1-7a': {
      type: 'comment',
      comment: 'Система дополнительного образования – это:',
      answerList: [
        ['Кружки и секции.', 'selected'],
        ['Дополнительные занятия учителей с двоечниками. ', false]
      ],
      description: `<span>Правильный ответ!</span><p>Совокупность кружков и секций различной направленности – художественные, спортивные и т.п. При этом работать они могут как на самостоятельных площадках, так и на базе школ, а развитие допобразования в России – одно из основных направлений нацпроекта «Образование».</p>`,
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '1-finish'
    },
    '1-7b': {
      type: 'comment',
      comment: 'Система дополнительного образования – это:',
      answerList: [
        ['Кружки и секции.', false],
        ['Дополнительные занятия учителей с двоечниками.', 'selected']
      ],
      description: `<span>Неправильный ответ!</span><p>Ошибаетесь! Подтягивание двоечников – это именно дополнительные занятия, цель которых помочь освоить школьную программу отстающим. А дополнительное образование – это занятия в кружках и секциях, позволяющие получить знания, умения и навыки, выходящие за рамки школьной программы. Развитие допобразования в России – одно из основных направлений <a href="https://xn--80aapampemcchfmo7a3c9ehj.xn--p1ai/wizard?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=obrazovanie" target="_blank" rel="noopener noreferrer">нацпроекта «Образование».</a></p>`,
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '1-7'
    },

    '1-finish': {
      type: 'comment',
      comment: `
        <div class="content__final">
          <p>Ну что же, первый раунд позади. Вы завершили его, честно заработав звание «Знаток». Однако по итогам второго раунда можно повысить квалификацию, получив звание «Эксперт». Для этого надо лишь отличить, где правда, а где ложь. Попробуем?</p>

          <svg class="content__final-picture" width="126" height="169">
            <use xlink:href="#icon-finish-1"></use>
          </svg>
        </div>
      `,
      specialClass: 'content__step_last',
      description: null,
      button: true,
      buttonText: 'Играть сначала',
      textAfter: null,
      shareButton: {classNames: {mainWrapper: 'share__list', linkItem: 'share__social-link'}},
      endingScreen: false,
      testId: '0',
      next: 'reload'
    }
  }
},

{
  id: 2,
  title: `2-й раунд`,
  start: '2-1',
  steps: {
    'start': {
      type: 'comment',
      comment: '',
      description: `<p>ПРАВДА ИЛИ ЛОЖЬ?</p>`,
      specialClass: 'content__step_start',
      button: true,
      buttonText: 'Итак, поехали!',
      next: String(questionsArray[0])
    },
    '2-1': {
      type: 'simple-question',
      isMultiple: false,
      comment: '',
      description: `<p>Главная задача проекта «Успех каждого ребенка» нацпроекта «Образование» – сделать каждого школьника отличником.</p>`,
      answers: [
        {
          title: 'Правда',
          next: '2-1a'
        },
        {
          title: 'Ложь',
          next: '2-1b'
        },

      ],
    },
    '2-1a': {
      type: 'comment',
      comment: 'Главная задача проекта «Успех каждого ребенка» нацпроекта «Образование» – сделать каждого школьника отличником.',
      answerList: [
        ['Правда', 'selected'],
        ['Ложь', false]
      ],
      description: `<span>Неправильный ответ!</span><p>Неверно! Задача нацпроекта – максимальное раскрытие творческого потенциала каждого ребенка. Для ее выполнения нужна эффективная система выявления, поддержки и развития способностей и талантов у детей и молодежи, направленная на самоопределение и профессиональную ориентацию всех обучающихся. Ее и предстоит создать.</p>`,
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '2-1'
    },
    '2-1b': {
      type: 'comment',
      comment: 'Главная задача проекта «Успех каждого ребенка» нацпроекта «Образование» – сделать каждого школьника отличником.',
      answerList: [
        ['Правда', false],
        ['Ложь', 'selected']
      ],
      description: `<span>Правильный ответ!</span><p>Конечно, ложь. Школьные отметки – не показатель жизненного успеха или творческого потенциала учащегося, а лишь инструмент оценки освоения им той или иной темы. Задача нацпроекта – максимальное раскрытие творческого потенциала каждого ребенка.</p>`,
      ref: '#21',
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '2-2'
    },

    '2-2': {
      type: 'simple-question',
      isMultiple: false,
      comment: '',
      description: `<p>Учащиеся российских школ при желании смогут изучать часть предметов в других учебных заведениях.</p>`,
      answers: [
        {
          title: 'Правда',
          next: '2-2a'
        },
        {
          title: 'Ложь',
          next: '2-2b'
        },

      ],
    },
    '2-2a': {
      type: 'comment',
      comment: 'Учащиеся российских школ при желании смогут изучать часть предметов в других учебных заведениях.',
      answerList: [
        ['Правда', 'selected'],
        ['Ложь', false]
      ],
      description: `<span>Правильный ответ!</span><p>Все правильно! Развивая творческий потенциал своих учащихся, школы смогут вести обучение в сетевой форме. Что это такое, мы уже знаем, а значит, понимаем: благодаря <a href="https://xn--80aapampemcchfmo7a3c9ehj.xn--p1ai/projects/obrazovanie?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=obrazovanie" target="_blank" rel="noopener noreferrer">нацпроекту «Образование»</a> ребята смогут изучать некоторые предметы, курсы, дисциплины, модули, практики и иные части образовательных программ, используя ресурсы других образовательных организаций.</p>`,
      ref: '#22',
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '2-3'
    },
    '2-2b': {
      type: 'comment',
      comment: 'Учащиеся российских школ при желании смогут изучать часть предметов в других учебных заведениях.',
      answerList: [
        ['Правда', false],
        ['Ложь', 'selected']
      ],
      description: `<span>Неправильный ответ!</span><p>Не верите в возможность учиться в нескольких школах сразу? Зря! Нацпроектом «Образование» предусмотрена возможность обучения в сетевой форме. Что это такое, мы уже знаем, а значит, понимаем: ребята смогут изучать некоторые предметы, курсы, дисциплины, модули, практики и иные части образовательных программ, используя ресурсы других образовательных организаций.</p>`,
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '2-2'
    },

    '2-3': {
      type: 'simple-question',
      isMultiple: false,
      comment: '',
      description: `<p>Ученикам 5–11-х классов разрешат учиться по индивидуальному учебному плану с зачетом результатов освоения дополнительных общеобразовательных программ и программ профессионального обучения.</p>`,
      answers: [
        {
          title: 'Правда',
          next: '2-3a'
        },
        {
          title: 'Ложь',
          next: '2-3b'
        },

      ],
    },
    '2-3a': {
      type: 'comment',
      comment: 'Ученикам 5–11-х классов разрешат учиться по индивидуальному учебному плану с зачетом результатов освоения дополнительных общеобразовательных программ и программ профессионального обучения.',
      answerList: [
        ['Правда', 'selected'],
        ['Ложь', false]
      ],
      description: `<span>Правильный ответ!</span><p>Так и есть: <a href="https://xn--80aapampemcchfmo7a3c9ehj.xn--p1ai/projects/obrazovanie?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=obrazovanie" target="_blank" rel="noopener noreferrer">нацпроект «Образование»</a> предусматривает возможность обучения по индивидуальному плану с зачетом в своей школе результатов дополнительного образования. Например, обучения в художественной школе.</p>`,
      ref: '#23',
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '2-4'
    },
    '2-3b': {
      type: 'comment',
      comment: 'Ученикам 5–11-х классов разрешат учиться по индивидуальному учебному плану с зачетом результатов освоения дополнительных общеобразовательных программ и программ профессионального обучения.',
      answerList: [
        ['Правда', false],
        ['Ложь', 'selected']
      ],
      description: `<span>Неправильный ответ!</span><p>Заблуждаетесь: в российских школах по индивидуальным планам уже и сейчас учатся не только ребята с проблемами здоровья, но и многие другие. А нацпроект предусматривает расширение этой практики для создания максимально творческой образовательной среды.</p>`,
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '2-3'
    },

    '2-4': {
      type: 'simple-question',
      isMultiple: false,
      comment: '',
      description: `<p>Нацпроект «Образование» нацелен только на создание крупных всероссийских центров выявления, поддержки и развития способностей и талантов у детей и молодежи, вроде «Сириуса» или «Артека».</p>`,
      answers: [
        {
          title: 'Правда',
          next: '2-4a'
        },
        {
          title: 'Ложь',
          next: '2-4b'
        },

      ],
    },
    '2-4a': {
      type: 'comment',
      comment: 'Нацпроект «Образование» нацелен только на создание крупных всероссийских центров выявления, поддержки и развития способностей и талантов у детей и молодежи, вроде «Сириуса» или «Артека».',
      answerList: [
        ['Правда', 'selected'],
        ['Ложь', false]
      ],
      description: `<span>Неправильный ответ!</span><p>Ничего подобного! <a href="https://xn--80aapampemcchfmo7a3c9ehj.xn--p1ai/projects/obrazovanie/vyyavlenie_talantov?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=obrazovanie" target="_blank" rel="noopener noreferrer">Проект «Успех каждого ребенка»</a>, входящий в нацпроект «Образование», предусматривает создание региональных центров выявления, поддержки и развития способностей и талантов у детей и молодежи во всех 85 российских регионах к 2024 году.</p>`,
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '2-4'
    },
    '2-4b': {
      type: 'comment',
      comment: 'Нацпроект «Образование» нацелен только на создание крупных всероссийских центров выявления, поддержки и развития способностей и талантов у детей и молодежи, вроде «Сириуса» или «Артека».',
      answerList: [
        ['Правда', false],
        ['Ложь', 'selected']
      ],
      description: `<span>Правильный ответ!</span><p>Да, это неправда. В каждом регионе, плюс к всероссийским, благодаря нацпроекту «Образование» будет еще и свой аналог «Сириуса» или «Артека».</p>`,
      ref: '#24',
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '2-5'
    },

    '2-5': {
      type: 'simple-question',
      isMultiple: false,
      comment: '',
      description: `<p>Нацпроект «Образование» – это про учебу в школе, колледже или вузе, а не про дополнительные занятия творчеством в секциях и кружках.</p>`,
      answers: [
        {
          title: 'Правда',
          next: '2-5a'
        },
        {
          title: 'Ложь',
          next: '2-5b'
        },

      ],
    },
    '2-5a': {
      type: 'comment',
      comment: 'Нацпроект «Образование» – это про учебу в школе, колледже или вузе, а не про дополнительные занятия творчеством в секциях и кружках.',
      answerList: [
        ['Правда', 'selected'],
        ['Ложь', false]
      ],
      description: `<span>Неправильный ответ!</span><p>«Поздравляю вас, гражданин, соврамши», – говорил в таких случаях булгаковский кот Бегемот. Нацпроект устанавливает: в 2024 году дополнительным образованием должны быть охвачены 80% детей и подростков от 5 до 18 лет. Для достижения этой цели к концу 2024 года в 85 регионах страны будут построены 245 детских технопарков «Кванториум» и 340 мобильных технопарков. Уже сейчас таких центров по стране больше 130.</p>`,
      ref: '#25',
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '2-5'
    },
    '2-5b': {
      type: 'comment',
      comment: 'Нацпроект «Образование» – это про учебу в школе, колледже или вузе, а не про дополнительные занятия творчеством в секциях и кружках.',
      answerList: [
        ['Правда', false],
        ['Ложь', 'selected']
      ],
      description: `<span>Правильный ответ!</span><p>Конечно же, ложь! Нацпроект устанавливает: к 2024 году дополнительным образованием должны быть охвачены 80% детей и подростков от 5 до 18 лет. Для достижения этой цели к концу 2024 года в 85 регионах страны будут построены 245 детских технопарков «Кванториум» и 340 мобильных технопарков. Уже сейчас таких центров по стране больше 130 и 70 соответственно. И это лишь часть возможностей. <a href="https://xn--80aapampemcchfmo7a3c9ehj.xn--p1ai/projects/obrazovanie?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=obrazovanie" target="_blank" rel="noopener noreferrer">Узнай больше на национальныепроекты.рф.</a></p>`,
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '2-6'
    },

    '2-6': {
      type: 'simple-question',
      isMultiple: false,
      comment: '',
      description: `<p>Нацпроект «Образование» касается только учащихся, а не малышей ясельного возраста.</p>`,
      answers: [
        {
          title: 'Правда',
          next: '2-6a'
        },
        {
          title: 'Ложь',
          next: '2-6b'
        },

      ],
    },
    '2-6a': {
      type: 'comment',
      comment: 'Нацпроект «Образование» касается только учащихся, а не малышей ясельного возраста.',
      answerList: [['Правда', 'selected'], ['Ложь', false]],
      description: `<span>Неправильный ответ!</span><p>Это утверждение не соответствует действительности! Нацпроект нацелен на создание условий для раннего развития творческого потенциала детей в возрасте до трех лет! И с этой целью вводит специальные программы психолого-педагогической, методической и консультативной помощи родителям детей, получающих дошкольное образование не в садике, а в семье.</p>`,
      ref: '#26',
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '2-6'
    },
    '2-6b': {
      type: 'comment',
      comment: 'Нацпроект «Образование» касается только учащихся, а не малышей ясельного возраста.',
      answerList: [['Правда', false], ['Ложь', 'selected']],
      description: `<span>Правильный ответ!</span><p>Ошибка думать, что интеллектуальное развитие ребенка начинается только в школе! Этот процесс идет с первых же месяцев его жизни, и чтобы  сделать его эффективным, проект «Поддержка семей, имеющих детей» в рамках нацпроекта «Образование» предусматривает, что <a href="https://xn--80aapampemcchfmo7a3c9ehj.xn--p1ai/projects/obrazovanie?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=obrazovanie" target="_blank" rel="noopener noreferrer">к 2024 году родители получат не менее 20 млн консультаций специалистов</a>: психологов, педагогов и методистов. Оцените эти масштабы!</p>`,
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '2-7'
    },

    '2-7': {
      type: 'simple-question',
      isMultiple: false,
      comment: '',
      description: `<p>Около 1 млн школьников смогут выбрать учебный план, исходя из своих склонностей к той или иной профессии.</p>`,
      answers: [
        {
          title: 'Правда',
          next: '2-7a'
        },
        {
          title: 'Ложь',
          next: '2-7b'
        },
      ],
    },
    '2-7a': {
      type: 'comment',
      comment: 'Около 1 млн школьников смогут выбрать учебный план, исходя из своих склонностей к той или иной профессии.',
      answerList: [
        ['Правда', 'selected'],
        ['Ложь', false]
      ],
      description: `<span>Правильный ответ!</span><p>Действительно, к 2024 году не менее 900 тыс. детей получат рекомендации по построению индивидуального учебного плана в соответствии с заинтересовавшими их профессиональными областями деятельности.</p>`,
      ref: '#27',
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '2-finish'
    },
    '2-7b': {
      type: 'comment',
      comment: 'Около 1 млн школьников смогут выбрать учебный план, исходя из своих склонностей к той или иной профессии.',
      answerList: [
        ['Правда', false],
        ['Ложь', 'selected']
      ],
      description: `<span>Неправильный ответ!</span><p>Ошибаетесь, это чистая правда, хотя, возможно, пока звучит фантастично. Чтобы убедиться в этом, ознакомьтесь, к примеру, с проектом ранней <a href="https://bilet.worldskills.ru" target="_blank" rel="noopener noreferrer">профориентации детей «Билет в будущее»</a>, реализация которого позволит достичь этого результата.</p>`,
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '2-7'
    },

    '2-finish': {
      type: 'comment',
      comment: `
      <div class="content__final">
        <p>Обогатившись этими познаниями, вы точно заслуживаете звание «Эксперт». Но есть возможность получить высшее звание – «Магистр». Рискнете?</p>

        <svg class="content__final-picture" width="163" height="151">
          <use xlink:href="#icon-finish-2"></use>
        </svg>
      </div>
      `,
      specialClass: 'content__step_last',
      description: null,
      button: true,
      buttonText: 'Играть сначала',
      textAfter: null,
      shareButton: {classNames: {mainWrapper: 'share__list', linkItem: 'share__social-link'}},
      endingScreen: false,
      testId: '1',
      next: 'reload'
    }
  }
},

{
  id: 3,
  title: `3-й раунд`,
  start: '3-1',
  steps: {
    'start': {
      type: 'comment',
      comment: '',
      description: null,
      specialClass: 'content__step_start',
      button: true,
      buttonText: 'Итак, поехали!',
      next: String(questionsArray[0])
    },
    '3-1': {
      type: 'simple-question',
      isMultiple: false,
      comment: '',
      description: `<p>Какие задачи ставит нацпроект по части внедрения в российское образование современных цифровых технологий и высокоскоростного Интернета?</p>`,
      answers: [
        {
          title: 'К 2024 году 100% российских школ будут обеспечены Интернетом со скоростью 50 Мб/с.',
          next: '3-1a'
        },
        {
          title: 'Обеспечить Интернетом  каждую школу страны.',
          next: '3-1b'
        },
        {
          title: 'Внедрение современных цифровых технологий в школьные программы охватит половину российских регионов.',
          next: '3-1c'
        },
        {
          title: 'Создание сети центров цифрового образования детей «IT-куб».',
          next: '3-1d'
        },

      ],
    },
    '3-1a': {
      type: 'comment',
      comment: 'Какие задачи ставит нацпроект по части внедрения в российское образование современных цифровых технологий и высокоскоростного Интернета?',
      answerList: [
        ['К 2024 году 100% российских школ будут обеспечены Интернетом со скоростью 50 Мб/с.', 'selected'],
        ['Обеспечить Интернетом  каждую школу страны.', false],
        ['Внедрение современных цифровых технологий в школьные программы охватит половину российских регионов.', false],
        ['Создание сети центров цифрового образования детей «IT-куб».', false]
      ],
      description: `<span>Неправильный ответ!</span><p>Ошибка! В век цифровых технологий образование должно идти в ногу со временем, а это требует более существенного усиления мощности школьных интернет-трафиков. Уже сейчас 15,5 тыс. школ оснащены высокоскоростным Интернетом, а <a href="https://futurerussia.gov.ru/nacionalnye-proekty/v-minprosvesenia-rasskazali-kakie-izmenenia-zdet-nacproekt-obrazovanie?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=obrazovanie" target="_blank" rel="noopener noreferrer">в 2021 году планируется оснастить все школы страны.</a></p>`,
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '3-1'
    },
    '3-1b': {
      type: 'comment',
      comment: 'Какие задачи ставит нацпроект по части внедрения в российское образование современных цифровых технологий и высокоскоростного Интернета?',
      answerList: [
        ['К 2024 году 100% российских школ будут обеспечены Интернетом со скоростью 50 Мб/с.', false],
        ['Обеспечить Интернетом  каждую школу страны.', 'selected'],
        ['Внедрение современных цифровых технологий в школьные программы охватит половину российских регионов.', false],
        ['Создание сети центров цифрового образования детей «IT-куб».', false]
      ],
      description: `<span>Правильный ответ!</span><p><a href="https://xn--80aapampemcchfmo7a3c9ehj.xn--p1ai/projects/obrazovanie/umnaya_shkola?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=obrazovanie" target="_blank" rel="noopener noreferrer">Проект «Цифровая образовательная среда»</a> нацпроекта «Образование» предусматривает полностью обеспечить Интернетом со скоростью 50 Мб/с сельские школы. Во всех городских школах страны будет Интернет со скоростью соединения не менее 100 Мб/с. 15,5 тыс. школ уже оснащены высокоскоростным Интернетом, а в 2021 году планируется оснастить все школы страны.</p>`,
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '3-2'
    },
    '3-1c': {
      type: 'comment',
      comment: 'Какие задачи ставит нацпроект по части внедрения в российское образование современных цифровых технологий и высокоскоростного Интернета?',
      answerList: [
        ['К 2024 году 100% российских школ будут обеспечены Интернетом со скоростью 50 Мб/с.', false],
        ['Обеспечить Интернетом  каждую школу страны.', false],
        ['Внедрение современных цифровых технологий в школьные программы охватит половину российских регионов.', 'selected'],
        ['Создание сети центров цифрового образования детей «IT-куб».', false]
      ],
      description: `<span>Неправильный ответ!</span><p>Увы, недооценили вы масштабы нацпроекта «Образование». В 2021 году во все школы будет проведен Интернет, а около 14,9 тыс. школ будут оснащены современным оборудованием – ноутбуками, многофункциональными устройствами, интерактивными досками. <a href="https://xn--80aapampemcchfmo7a3c9ehj.xn--p1ai/projects/obrazovanie/stroitelstvo_shkol" target="_blank" rel="noopener noreferrer">К 2024 году во всех школах страны будет современное оборудование.</a></p>`,
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '3-1'
    },
    '3-1d': {
      type: 'comment',
      comment: 'Какие задачи ставит нацпроект по части внедрения в российское образование современных цифровых технологий и высокоскоростного Интернета?',
      answerList: [
        ['К 2024 году 100% российских школ будут обеспечены Интернетом со скоростью 50 Мб/с.', false],
        ['Обеспечить Интернетом  каждую школу страны.', false],
        ['Внедрение современных цифровых технологий в школьные программы охватит половину российских регионов.', false],
        ['Создание сети центров цифрового образования детей «IT-куб».', 'selected']
      ],
      description: `<span>Неправильный ответ!</span><p>Уже сейчас <a href="https://xn--80aapampemcchfmo7a3c9ehj.xn--p1ai/news/vr-ar-i-programmirovanie-robotov-chemu-uchat-shkolnikov-v-novykh-it-kubakh?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=obrazovanie" target="_blank" rel="noopener noreferrer">таких цифровых центров в России</a> более 60, а к 2024 году их будет 340. Это одна из задач нацпроекта «Образование». Кроме того, в 2021 году во все школы будет проведен Интернет, а около 14,9 тыс. школ будут оснащены современным оборудованием – ноутбуками, многофункциональными устройствами, интерактивными досками. К 2024 году во всех школах страны будет современное оборудование.</p>`,
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '3-1'
    },

    '3-2': {
      type: 'simple-question',
      isMultiple: false,
      comment: '',
      description: `<p>Какой предмет в эру новых цифровых технологий ждет полное обновление?</p>`,
      answers: [
        {
          title: 'Информатика.',
          next: '3-2a'
        },
        {
          title: 'Иностранные языки.',
          next: '3-2b'
        },
        {
          title: 'Школьная математика.',
          next: '3-2c'
        },
        {
          title: 'Технология.',
          next: '3-2d'
        },
      ],
    },
    '3-2a': {
      type: 'comment',
      comment: 'Какой предмет в эру новых цифровых технологий ждет полное обновление?',
      answerList: [
        ['Информатика.', 'selected'],
        ['Иностранные языки.', false],
        ['Школьная математика.', false],
        ['Технология.', false]
      ],
      description: `<span>Неправильный ответ!</span><p>Нет, цифровые технологии, конечно, крайне важны в современном мире! Но в отношении предмета «Информатика и ИКТ» изменения коснутся только формы сдачи ЕГЭ, которая с будущего года полностью станет электронной.</p>`,
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '3-2'
    },
    '3-2b': {
      type: 'comment',
      comment: 'Какой предмет в эру новых цифровых технологий ждет полное обновление?',
      answerList: [
        ['Информатика.', false],
        ['Иностранные языки.', 'selected'],
        ['Школьная математика.', false],
        ['Технология.', false]
      ],
      description: `<span>Неправильный ответ!</span><p>Языковые онлайн-курсы, конечно, можно и нужно использовать, но содержание данного предмета от этого не меняется.</p>`,
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '3-2'
    },
    '3-2c': {
      type: 'comment',
      comment: 'Какой предмет в эру новых цифровых технологий ждет полное обновление?',
      answerList: [
        ['Информатика.', false],
        ['Иностранные языки.', false],
        ['Школьная математика.', 'selected'],
        ['Технология.', false]
      ],
      description: `<span>Неправильный ответ!</span><p>Нет, в школьной математике все остается как было, включая сдачу ЕГЭ на одном из двух уровней – базовом или профильном.</p>`,
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '3-2'
    },
    '3-2d': {
      type: 'comment',
      comment: 'Какой предмет в эру новых цифровых технологий ждет полное обновление?',
      answerList: [
        ['Информатика.', false],
        ['Иностранные языки.', false],
        ['Школьная математика.', false],
        ['Технология.', 'selected']
      ],
      description: `<span>Правильный ответ!</span><p>Предмет, ранее известный как «Труд», выходит на новый, современный уровень. Это предусмотрено <a href="https://xn--80aapampemcchfmo7a3c9ehj.xn--p1ai/projects/obrazovanie?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=obrazovanie" target="_blank" rel="noopener noreferrer">нацпроектом «Образование»</a>. Школьники будут получать там навыки, необходимые для решения инженерных задач широкого диапазона: от создания механических игрушек до проектирования гидравлических механизмов.</p>`,
      ref: '#32',
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '3-3'
    },

    '3-3': {
      type: 'simple-question',
      isMultiple: false,
      comment: '',
      description: `<p>В чем суть <a href="https://bilet.worldskills.ru/about?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=obrazovanie" target="_blank" rel="noopener noreferrer">проекта «Билет в будущее»?</a></p>`,
      answers: [
        {
          title: 'Возможность на практике познакомиться с самыми разными профессиями.',
          next: '3-3a'
        },
        {
          title: 'Возвращение обязательного распределения после окончания вузов.',
          next: '3-3b'
        },
        {
          title: 'Обучение в колледжах по новейшим технологиям.',
          next: '3-3c'
        },
        {
          title: 'Знакомство старшеклассников с разными специальностями.',
          next: '3-3d'
        },
      ],
    },
    '3-3a': {
      type: 'comment',
      comment: `В чем суть&nbsp; <a href="https://bilet.worldskills.ru/about?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=obrazovanie" target="_blank" rel="noopener noreferrer">проекта «Билет в будущее»?</a>`,
      answerList: [
        ['Возможность на практике познакомиться с самыми разными профессиями.', 'selected'],
        ['Возвращение обязательного распределения после окончания вузов.', false],
        ['Обучение в колледжах по новейшим технологиям.', false],
        ['Знакомство старшеклассников с разными специальностями.', false],
      ],
      description: `<span>Правильный ответ!</span><p>В 2020 году участие в проекте благодаря нацпроекту «Образование» приняли более 1,5 млн ребят со всех регионов страны, и это не предел. <a href="https://xn--80adjbxl0aeb4ii6a.xn--p1ai/?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=obrazovanie" target="_blank" rel="noopener noreferrer">«Мы не выбираем профессию, а учим, как выбирать</a>, – уточняют руководители проекта. – Для выбора профессии в меняющемся мире мало знать, какие профессии существуют,  важно уметь выбирать свой путь».</p>`,
      ref: '#33',
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '3-4'
    },
    '3-3b': {
      type: 'comment',
      comment: `В чем суть&nbsp; <a href="https://bilet.worldskills.ru/about?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=obrazovanie" target="_blank" rel="noopener noreferrer">проекта «Билет в будущее»?</a>`,
      answerList: [
        ['Возможность на практике познакомиться с самыми разными профессиями.', false],
        ['Возвращение обязательного распределения после окончания вузов.', 'selected'],
        ['Обучение в колледжах по новейшим технологиям.', false],
        ['Знакомство старшеклассников с разными специальностями.', false],
      ],
      description: `<span>Неправильный ответ!</span><p>Ни в коем случае! Проект рассчитан не на студентов, а на школьников: он познакомит ребят 6–11-х классов с самыми разными профессиями. В рамках нацпроекта «Образование» в 2020 году участие в проекте «Билет будущего» приняли более 1,5 млн детей со всех регионов страны.</p>`,
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '3-3'
    },
    '3-3c': {
      type: 'comment',
      comment: `В чем суть&nbsp; <a href="https://bilet.worldskills.ru/about?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=obrazovanie" target="_blank" rel="noopener noreferrer">проекта «Билет в будущее»?</a>`,
      answerList: [
        ['Возможность на практике познакомиться с самыми разными профессиями.', false],
        ['Возвращение обязательного распределения после окончания вузов.', false],
        ['Обучение в колледжах по новейшим технологиям.', 'selected'],
        ['Знакомство старшеклассников с разными специальностями.', false],
      ],
      description: `<span>Неправильный ответ!</span><p>Такая работа, действительно, идет, но в рамках другого проекта – <a href="https://bilet.worldskills.ru/about?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=obrazovanie" target="_blank" rel="noopener noreferrer">«Молодые профессионалы» нацпроекта «Образование».</a> «Билет в будущее» – масштабный проект ранней профориентации школьников 6–11-х классов с самыми разными профессиями.</p>`,
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '3-3'
    },
    '3-3d': {
      type: 'comment',
      comment: `В чем суть&nbsp; <a href="https://bilet.worldskills.ru/about?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=obrazovanie" target="_blank" rel="noopener noreferrer">проекта «Билет в будущее»?</a>`,
      answerList: [
        ['Возможность на практике познакомиться с самыми разными профессиями.', false],
        ['Возвращение обязательного распределения после окончания вузов.', false],
        ['Обучение в колледжах по новейшим технологиям.', false],
        ['Знакомство старшеклассников с разными специальностями.', 'selected'],
      ],
      description: `<span>Неправильный ответ!</span><p>Почти угадали! Но в рамках нацпроекта «Образование» речь идет не только о старшеклассниках, но и о более ранней <a href="https://bilet.worldskills.ru/?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=obrazovanie" target="_blank" rel="noopener noreferrer">профориентации школьников – начиная с 6-го класса.</a> Узнайте о проекте больше!</p>`,
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '3-3'
    },

    '3-4': {
      type: 'simple-question',
      isMultiple: false,
      comment: '',
      description: `<p>Какие перемены ждут  профессиональное образование?</p>`,
      answers: [
        {
          title: 'Повышение конкурса для поступающих в колледжи.',
          next: '3-4a'
        },
        {
          title: 'В колледжах будут изучать фундаментальные науки.',
          next: '3-4b'
        },
        {
          title: 'Удлинение срока обучения в колледжах.',
          next: '3-4c'
        },
        {
          title: 'Модернизация учебного оборудования и внедрение гибких образовательных программ.',
          next: '3-4d'
        },

      ],
    },
    '3-4a': {
      type: 'comment',
      comment: 'Какие перемены ждут  профессиональное образование?',
      answerList: [
        ['Повышение конкурса для поступающих в колледжи.', 'selected'],
        ['В колледжах будут изучать фундаментальные науки.', false],
        ['Удлинение срока обучения в колледжах.', false],
        ['Модернизация учебного оборудования и внедрение гибких образовательных программ.', false]
      ],
      description: `<span>Неправильный ответ!</span><p>Нет, искусственное завышение конкурса может разбалансировать всю систему профобразования, выполняющую, помимо образовательной, еще и социальную миссию, и тем самым принести ей не пользу, а вред. Одна из важнейших задач нацпроекта «Образование» – модернизация профобразования путем замены учебного оборудования на современное, а образовательных программ – на более гибкие и приближенные к потребностям экономики.</p>`,
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '3-4'
    },
    '3-4b': {
      type: 'comment',
      comment: 'Какие перемены ждут  профессиональное образование?',
      answerList: [
        ['Повышение конкурса для поступающих в колледжи.', false],
        ['В колледжах будут изучать фундаментальные науки.', 'selected'],
        ['Удлинение срока обучения в колледжах.', false],
        ['Модернизация учебного оборудования и внедрение гибких образовательных программ.', false]
      ],
      description: `<span>Неправильный ответ!</span><p>Неверно! Данная модель обучения хороша в основном для классических университетов, выпускающих ученых-теоретиков. Ниша колледжей – технологии и прикладные науки.</p>`,
      ref: '#34-1',
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '3-4'
    },
    '3-4c': {
      type: 'comment',
      comment: 'Какие перемены ждут  профессиональное образование?',
      answerList: [
        ['Повышение конкурса для поступающих в колледжи.', false],
        ['В колледжах будут изучать фундаментальные науки.', false],
        ['Удлинение срока обучения в колледжах.', 'selected'],
        ['Модернизация учебного оборудования и внедрение гибких образовательных программ.', false]
      ],
      description: `<span>Неправильный ответ!</span><p>Тоже не имеет смысла: учебные программы в системе среднего профобразования тесно связаны с быстро меняющимися, а значит, быстро устаревающими технологиями, а потому должны быть компактными.</p>`,
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '3-4'
    },
    '3-4d': {
      type: 'comment',
      comment: 'Какие перемены ждут  профессиональное образование?',
      answerList: [
        ['Повышение конкурса для поступающих в колледжи.', false],
        ['В колледжах будут изучать фундаментальные науки.', false],
        ['Удлинение срока обучения в колледжах.', false],
        ['Модернизация учебного оборудования и внедрение гибких образовательных программ.', 'selected']
      ],
      description: `<span>Вот правильный ответ!</span><p>Учебные курсы системы среднего профобразования должны, с одной стороны, успевать за развитием технологий, а с другой, вооружать студентов практическими навыками применения своих познаний на практике. Эта задача будет решена <a href="https://xn--80aapampemcchfmo7a3c9ehj.xn--p1ai/projects/obrazovanie?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=obrazovanie" target="_blank" rel="noopener noreferrer">благодаря нацпроекту «Образование».</a></p>`,
      ref: '#34-2',
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '3-5'
    },

    '3-5': {
      type: 'simple-question',
      isMultiple: false,
      comment: '',
      description: `<p>Кому государство предоставляет возможности для профессионального и карьерного роста?</p>`,
      answers: [
        {
          title: 'Карьерный рост – удел избранных единиц.',
          next: '3-5a'
        },
        {
          title: 'Тысяче лучших.',
          next: '3-5b'
        },
        {
          title: 'Эти возможности практически не ограничены.',
          next: '3-5c'
        },
        {
          title: 'Миллиону человек.',
          next: '3-5d'
        },

      ],
    },
    '3-5a': {
      type: 'comment',
      comment: 'Кому государство предоставляет возможности для профессионального и карьерного роста?',
      answerList: [
        ['Карьерный рост – удел избранных единиц.', 'selected'],
        ['Тысяче лучших.', false],
        ['Эти возможности практически не ограничены.', false],
        ['Миллиону человек.', false],
      ],
      description: `<span>Неправильный ответ!</span><p>Это не так. Национальный проект «Образование» предоставляет возможности для карьерного и профессионального роста миллионов людей. Подтверждение тому – президентская платформа «Россия – страна возможностей», которая ежегодно проводит более 25 профессиональных конкурсов и уже привлекла 4 млн участников. <a href="https://rsv.ru/marketing/index.html?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=obrazovanie" target="_blank" rel="noopener noreferrer">Ознакомиться с ними можно на сайте rsv.ru.</a></p>`,
      ref: '#35',
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '3-5'
    },
    '3-5b': {
      type: 'comment',
      comment: 'Кому государство предоставляет возможности для профессионального и карьерного роста?',
      answerList: [
        ['Карьерный рост – удел избранных единиц.', false],
        ['Тысяче лучших.', 'selected'],
        ['Эти возможности практически не ограничены.', false],
        ['Миллиону человек.', false],
      ],
      description: `<span>Неправильный ответ!</span><p>Мимо! Благодаря нацпроекту «Образование» участников на порядок больше.</p>`,
      ref: '#35',
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '3-5'
    },
    '3-5c': {
      type: 'comment',
      comment: 'Кому государство предоставляет возможности для профессионального и карьерного роста?',
      answerList: [
        ['Карьерный рост – удел избранных единиц.', false],
        ['Тысяче лучших.', false],
        ['Эти возможности практически не ограничены.', 'selected'],
        ['Миллиону человек.', false],
      ],
      description: `<span>Правильный ответ!</span><p>Да! Благодаря <a href="https://xn--80aapampemcchfmo7a3c9ehj.xn--p1ai/opportunities/prokachat-svoyu-kareru?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=obrazovanie" target="_blank" rel="noopener noreferrer">нацпроекту «Образование»</a>, в 35 таких конкурсах к 2024 году примут участие миллионы россиян. А уже сейчас президентская платформа «Россия – страна возможностей» проводит более 25 профессиональных конкурсов и привлекла 4 млн участников!</p>`,
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '3-6'
    },
    '3-5d': {
      type: 'comment',
      comment: 'Кому государство предоставляет возможности для профессионального и карьерного роста?',
      answerList: [
        ['Карьерный рост – удел избранных единиц.', false],
        ['Тысяче лучших.', false],
        ['Эти возможности практически не ограничены.', false],
        ['Миллиону человек.', 'selected'],
      ],
      description: `<span>Неправильный ответ!</span><p>Слишком скромное предположение. «Россия сосредотачивается», – как некогда писал канцлер Горчаков. На руководящие посты разного уровня по всей стране должно прийти много новых людей и конкурсы уже охватили около миллионы человек.</p>`,
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '3-5'
    },

    '3-6': {
      type: 'simple-question',
      isMultiple: false,
      comment: '',
      description: `<p>Как должна выглядеть российская школа на международном уровне?</p>`,
      answers: [
        {
          title: 'А нам вообще незачем равняться «на заграницу»!',
          next: '3-6a'
        },
        {
          title: 'Международный опыт не годится для наших школьников!',
          next: '3-6b'
        },
        {
          title: 'Стать первой в мире по качеству образовательных стандартов!',
          next: '3-6c'
        },
        {
          title: 'Войти в десятку стран мира по качеству образования!',
          next: '3-6d'
        },
      ],
    },
    '3-6a': {
      type: 'comment',
      comment: 'Как должна выглядеть российская школа на международном уровне?',
      answerList: [
        ['А нам вообще незачем равняться «на заграницу»!', 'selected'],
        ['Международный опыт не годится для наших школьников!', false],
        ['Стать первой в мире по качеству образовательных стандартов!', false],
        ['Войти в десятку стран мира по качеству образования!', false],
      ],
      description: `<span>Неправильный ответ!</span><p>Это не так. Наложение нашей «картинки» образования на зарубежные служит отличным инструментом для выявления потенциальных точек роста российской школы. Нацпроект «Образование» предоставляет для этого все возможности.</p>`,
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '3-6'
    },
    '3-6b': {
      type: 'comment',
      comment: 'Как должна выглядеть российская школа на международном уровне?',
      answerList: [
        ['А нам вообще незачем равняться «на заграницу»!', false],
        ['Международный опыт не годится для наших школьников!', 'selected'],
        ['Стать первой в мире по качеству образовательных стандартов!', false],
        ['Войти в десятку стран мира по качеству образования!', false],
      ],
      description: `<span>Неправильный ответ!</span><p>Результаты международных исследований подтверждают, что вы ошибаетесь. Наши ребята хорошо справляются с этими заданиями и традиционно показывают высокие, а то и высочайшие результаты в таких исследованиях, как PIRLS, PISA или TIMSS. К 2024 году нацпроект «Образование» предусматривает, что Россия должна войти в число ведущих 10 стран мира по качеству общего образования.</p>`,
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '3-6'
    },
    '3-6c': {
      type: 'comment',
      comment: 'Как должна выглядеть российская школа на международном уровне?',
      answerList: [
        ['А нам вообще незачем равняться «на заграницу»!', false],
        ['Международный опыт не годится для наших школьников!', false],
        ['Стать первой в мире по качеству образовательных стандартов!', 'selected'],
        ['Войти в десятку стран мира по качеству образования!', false],
      ],
      description: `<span>Неправильный ответ!</span><p>Хорошо бы, конечно! Но это перспектива будущего! А пока к 2024 году Россия должна войти в число ведущих 10 стран мира <a href="https://futurerussia.gov.ru/nacionalnye-proekty/putin-rf-dolzna-k-2030-godu-vojti-v-desatku-mirovyh-liderov-po-kacestvu-obsego-obrazovania?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=obrazovanie" target="_blank" rel="noopener noreferrer">по качеству общего образования.</a></p>`,
      button: true,
      buttonText: 'Вернитесь назад',
      specialClass: 'content__step_wrong',
      next: '3-6'
    },
    '3-6d': {
      type: 'comment',
      comment: 'Как должна выглядеть российская школа на международном уровне?',
      answerList: [
        ['А нам вообще незачем равняться «на заграницу»!', false],
        ['Международный опыт не годится для наших школьников!', false],
        ['Стать первой в мире по качеству образовательных стандартов!', false],
        ['Войти в десятку стран мира по качеству образования!', 'selected'],
      ],
      description: `<span>Правильный ответ!</span><p>В соответствии с нацпроектом «Образование» к 2024 году Россия должна войти в число ведущих 10 стран мира по качеству общего образования.</p>`,
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '3-finish'
    },

    '3-finish': {
      type: 'comment',
      comment: `
      <div class="content__final">
        <p>Ну теперь в вопросах образования вы, без сомнения, «Магистр»! Смело применяйте полученные знания на практике. Удачи!</p>

        <svg class="content__final-picture" width="200" height="151">
          <use xlink:href="#icon-finish-3"></use>
        </svg>
      </div>
      `,
      specialClass: 'content__step_last',
      description: null,
      button: true,
      buttonText: 'Играть сначала',
      textAfter: null,
      shareButton: {classNames: {mainWrapper: 'share__list', linkItem: 'share__social-link'}},
      endingScreen: false,
      testId: '2',
      next: 'reload'
    }
  }
}];

createOrder(GAME_1[0].steps, QUESTIONS_NUMBER, questionsArray);

export const jsonData = JSON.stringify(GAME_1);



// WEBPACK FOOTER //
// ./data/data.js